module.exports = __webpack_public_path__ + "static/media/avatar.cbb5addf.png";